import React, { Component, Fragment } from 'react';
import { Tabs as StyleguideTabs, SubHeading } from 'cw-styleguide-react';
import { withTranslation } from "react-i18next";
import { route } from "../routes";

class Tabs extends Component {
  render() {
    return (
      <Fragment>
        <SubHeading type='sub-heading-small' colour={'sub-heading-small--b'}>
          {this.props.t('browse_by')}
        </SubHeading>
        <StyleguideTabs
          type={'block'}
          items={[
            { title: this.props.t('az_title'), link: route('glossary') },
            { title: this.props.t('industry_title'), link: route('industries') },
            { title: this.props.t('subjects_title'), link: route('subjects') }
          ]}
        />
      </Fragment>
    )
  }
}

export default withTranslation('local')(Tabs);
